// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class AppStateService implements IHooksService {
   $q: any
   $window: any
   apiService: any
   defaults: any
   fire: any
   on: any
   off: any
   once: any
   isDefaultInclusion: any
   params: any
   searchScopeParams: any
   paramsSnapShot: any
   urlService: UrlService
   viewStateService: ViewStateService
   customizerUrl: String
   utilities: any
   constructor(apiService: any, urlService: any, $window: any, hooksService: any, configService: any, $q: any, viewStateService: ViewStateService, utilities: UtilitiesService) {
      this.resetParams = this.resetParams.bind(this)
      this.takeSnapShot = this.takeSnapShot.bind(this)
      this.filtersApplied = this.filtersApplied.bind(this)
      this.numberOfFiltersApplied = this.numberOfFiltersApplied.bind(this)
      this.applyState = this.applyState.bind(this)
      this.applyStateWithSnapShot = this.applyStateWithSnapShot.bind(this)
      this.rollbackState = this.rollbackState.bind(this)
      this.checkAppliedStatusForFullTextMatches = this.checkAppliedStatusForFullTextMatches.bind(this)
      this.getFullTextMatchesParameterValue = this.getFullTextMatchesParameterValue.bind(this)
      this.checkDefaultInclusion = this.checkDefaultInclusion.bind(this)
      this.applyStateFromUrlParams = this.applyStateFromUrlParams.bind(this)
      this.apiService = apiService
      this.urlService = urlService
      this.utilities = utilities
      this.$window = $window
      this.$q = $q
      this.customizerUrl = configService.data.customizer.customizerUrl + "/" + configService.data.head.client
      this.isDefaultInclusion = this.checkDefaultInclusion(configService.data.quickFilters)
      this.viewStateService = viewStateService
      this.defaults = {
         pn: 1,
         ho: true,
         'include.ft.matches': this.getFullTextMatchesParameterValue(configService.data.quickFilters),
         fvf: [],
         fvfi: [],
         myinst: '',
         jt: '',
         rf: [],
         l: this.$window.__summonLocale,
         searchscope: ''
      }
      this.resetParams()
      this.paramsSnapShot = {}

      hooksService.setHooks(this, 'AppStateService', ['apply'])
   }

   resetParams(resetSearchScope = true) {
      // need to do deep copy here or else defaults.fvf array can be overwritten
      // by pushes to params.fvf
      this.params = angular.copy(this.defaults, {})
      if(resetSearchScope) {
         this.searchScopeParams = angular.copy(this.defaults, {})
      }
   }

   takeSnapShot() {
      return this.paramsSnapShot = angular.copy(this.params)
   }

   filtersApplied() {
      return this.filtersAppliedBy(this.params) || this.filtersAppliedBy(this.searchScopeParams)
   }

   filtersAppliedBy(params: any) {
      return !params.ho || params.fvf.length || params.fvfi.length || params.rf.length || params.myinst || params.oaf || params['print.books.only'] || params['ebooks.only'] || this.checkAppliedStatusForFullTextMatches(params)
   }

   numberOfFiltersApplied() {
      let cnt = 0
      if (!this.params.ho || !this.searchScopeParams.ho) {
         cnt += 1
      }
      if (this.params.myinst || this.searchScopeParams.myinst) {
         cnt += 1
      }
      if (this.params.oaf || this.searchScopeParams.oaf) {
         cnt += 1
      }
      if (this.params['print.books.only'] || this.searchScopeParams['print.books.only']) {
         cnt += 1
      }
      if (this.params['ebooks.only'] || this.searchScopeParams['ebooks.only']) {
         cnt += 1
      }
      const includeFtMatchesRaw = this.params['include.ft.matches'] || this.searchScopeParams['include.ft.matches']
      const includeFtMatches = includeFtMatchesRaw === 'f' ? false : includeFtMatchesRaw
      if (includeFtMatches && !this.isDefaultInclusion) { 
         cnt+=1
      }
      cnt += this.params.fvf.length + this.searchScopeParams.fvf.length
      cnt += this.params.fvfi.length + this.searchScopeParams.fvfi.length
      cnt += this.params.rf.length + this.searchScopeParams.rf.length
      const duplicatedFacets = this.getNumOfFacetsDuplicated(this.params, this.searchScopeParams)
      return cnt -= duplicatedFacets
   }

   getNumOfFacetsDuplicated(params: any, searchScopeParams: any) {
      let duplicatedFacets = 0
      // for Content type, Discipline... 
      if(params.fvf.length && searchScopeParams.fvf.length) {
         // Parse by removing text after last comma (to include only the facets name, and not the value)
         const parsedParams = params.fvf.map((param: string) => param.substring(0, param.lastIndexOf(','))) // parsing example: 'ContentType,Book / eBook,f' => 'ContentType,Book / eBook'
         const parsedSearchParams = searchScopeParams.fvf.map((param: string) => param.substring(0, param.lastIndexOf(',')))
         duplicatedFacets += this.getDuplicatedFacetsCount(parsedParams, parsedSearchParams)
      }
      
      // for Publication Data, New records... 
      if(params.rf.length && searchScopeParams.rf.length) {
         // Parse be removing text after first comma occurence
         const parsedParams = params.rf.map((param: string) => param.split(',')[0]) // parsing example: 'NewRecords,90:*' => 'NewRecords'
         const parsedSearchParams = searchScopeParams.rf.map((param: string) => param.split(',')[0])
         duplicatedFacets += this.getDuplicatedFacetsCount(parsedParams, parsedSearchParams)
         
      }
      return duplicatedFacets

   }

   getDuplicatedFacetsCount(parsedParams: [], parsedSearchParams: []): number {
      let duplicatedFacets = 0
      // look for duplication and increase number of duplicatedFacets
      for(const parsedItem of parsedParams) {
         if(parsedSearchParams.includes(parsedItem)) {
            duplicatedFacets++
         }
      }
      return duplicatedFacets
   }

   applyState(opts = {isPageRequest:true}) {
      if (!opts.isPageRequest) { this.params.pn = 1 }
      this.clearSearchScopeIfBuildingScope(this.params)
      this.sendScopeIfBuildingScope()
      this.urlService.applyParams(this.params)
      const apiPromise = this.apiService.applyParams(_.omit(this.params))
      this.fire('apply', this.params.pn)
      return apiPromise
   }

   updatePageInUrl(pageNum: number) {
      this.params.pn = pageNum
      this.urlService.applyParams(this.params)
   }

   applyStateWithSnapShot(setState = angular.noop) {
      if (!_.isFunction(setState)) { throw new Error("takes a function") }
      this.takeSnapShot()
      setState()
      return this.applyState()
   }

   // A scope being built must only contain its own filters. A 'searchscope' param would make the API apply
   // another scope on top of them, and would be saved into the new scope's query by Customizer.
   clearSearchScopeIfBuildingScope(params: any) {
      if (this.viewStateService.scopeBuilderMode) {
         params.searchscope = ''
      }
   }

   sendScopeIfBuildingScope() {
      if(this.viewStateService.scopeBuilderMode){
         const paramsString = this.urlService.urlParamsStringFor(this.params)
         this.$window.parent.postMessage({query: paramsString}, "*") //`${this.customizerUrl}/settings#SearchScopes`
      }
   }

   rollbackState() {
      if (_.isEqual(this.params, this.paramsSnapShot)) { return }
      this.resetParams()
      angular.extend(this.params, this.paramsSnapShot)
      return this.applyState()
   }

   isDifferent(params: any, state: any) {
      for (var k in state) {
         var v = state[k]
         if (k !== 'pn') {
            if (!angular.equals(params[k], v)) { return true }
         }
      }
      // return true if list of keys are different
      if (_.difference(_.keys(params), _.keys(state)).length) { return true }
      return false
   }

   checkAppliedStatusForFullTextMatches(params: any) {
      if (this.isDefaultInclusion) {
         return false
      } else {
         return params['include.ft.matches'] !== 'f' &&  !!params['include.ft.matches']
      }
   }

   getFullTextMatchesParameterValue(quickFilters: any) {
      let param = ''
      _(quickFilters?.filters).map((f: any) => {
         if (f.facet === 'include.ft.matches') {
            if (f.value) {
               return param = 't'
            } else {
               return param = 'f'
            }
         }
      })
      return param
   }

   checkDefaultInclusion(quickFilters: any){
      let isDefault = false
      _(quickFilters?.filters).map((f: any) => {
         if (f.facet === 'include.ft.matches') {
            if (f.defaultInclusion) {
               return isDefault = true
            }
         }
      })
      return isDefault
   }

   dontIncludeFTMatchViaEmptySearchScope(searchScopeParams: any, selectedScopeQuery: string){
      if(!selectedScopeQuery){
         searchScopeParams['include.ft.matches'] = 'f'
      }
   }

   parseSearchScopeFromUrlParams(paramsString: string, searchScopeParams = this.searchScopeParams){
      let k
      const params = this.urlService.urlParamsFromString(paramsString)
      const state = $.extend(true, {}, this.defaults, this.urlService.toParams(params))
      this.dontIncludeFTMatchViaEmptySearchScope(state, paramsString)
      for (k in state) {
         delete searchScopeParams[k]
      }
      for (k of _.difference(_.keys(searchScopeParams), _.keys(state))) {
         delete searchScopeParams[k]
      }
      $.extend(searchScopeParams, state)
   }

   applyStateFromUrlParams(params: any) {
      let k
      const state = $.extend(true, {}, this.defaults, this.urlService.toParams(params))
      this.clearSearchScopeIfBuildingScope(state)
      const different = this.isDifferent(this.params, state)
      for (k in state) {
         delete this.params[k]
      }
      for (k of _.difference(_.keys(this.params), _.keys(state))) {
         delete this.params[k]
      }
      $.extend(this.params, state)
      if (different) {
         // send the cleaned query back so re-saving a scope with a stale 'searchscope' fixes it
         this.sendScopeIfBuildingScope()
         this.urlService.applyParams(this.params)
         const apiPromise = this.apiService.applyParams(this.params)
         this.fire('apply', this.params.pn)
         return apiPromise
      } else {
         return this.$q.resolve(true)
      }
   }
}

AppStateService.$inject = ['apiService', 'urlService', '$window', 'hooksService','configService', '$q', 'viewStateService', 'utilitiesService']

angular.module('summonApp.services')
   .service('appStateService', AppStateService)
